import assert from '@banking/ui/utils/assert';
export const formatPAN = pan => {
  assert(pan.length === 16);
  return [...pan].reduce((prev, next, i, arr) => `${prev}${next}${arr.length !== i + 1 && (i + 1) % 4 === 0 ? ' ' : ''}`);
};